<template>
  <div id="question-create-details-tab" @keyup.ctrl.enter="question_update_data">
    <div class="vx-col w-full">
      <div class="vx-row">
        <div class="vx-col w-1/2 mb-6">
          <h2 class="font-light mb-2 ml-1">Question ID</h2>
          <vs-input v-model="data_local.id" class="w-full" readonly />
        </div>
        <div class="vx-col w-1/2">
          <h2 class="font-light mb-2 ml-1">Question Type</h2>
          <v-select class="mb-3 w-full" :options="questionTypeOptions" v-model="data_local.type" />
        </div>
        <div class="vx-col w-1/2">
          <h2 class="font-light mb-2 ml-1">Question</h2>
          <vs-textarea v-model="data_local.question" height="250px" />
        </div>
        <div class="vx-col w-1/2">
          <h2 class="font-light mb-2 ml-1">Explanation Text</h2>
          <vs-textarea v-model="data_local.explanation_text" height="250px" />
        </div>
        <div class="vx-col w-1/2 mb-6">
          <h2 class="font-light mb-2 ml-1">Domain ID</h2>
          <vs-input v-model="data_local.domain_id" class="w-full" />
        </div>
        <div class="vx-col w-full mb-6" v-if="data_local.meta && data_local.meta.prompt">
          <h2 class="font-light mb-2 ml-1">Prompt</h2>
          <vs-input v-model="data_local.meta.prompt" class="w-full" />
        </div>
        <div class="vx-col w-full" :key="key">
          <h2 class="font-light mb-2 ml-1">Options & Answers</h2>
          <div v-for="(answer, index) in data_local.meta.options" :key="index" class="mb-6">
            <h4 class="font-light mb-2 ml-1">Answer {{ index }}</h4>
            <div class="flex items-center justify-center gap-2">
              <vs-switch v-model="answer.correct" @click="toggle_correct(index)" />
              <vs-input v-model="answer.text" class="w-full" />
              <feather-icon icon="Trash2Icon" svgClasses="h-8 w-8 text-danger cursor-pointer" @click="remove_answer(index)" />
            </div>
          </div>
          <vs-button class="mb-6" @click="add_answer">Add Aditional Answer</vs-button>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button class="mb-2 mr-2" color="success" type="filled" @click="question_update_data">Update Question </vs-button>
          <vs-button class="mb-2 ml-2" color="warning" type="border" @click="reset_data">Reset </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  data () {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      question_description_counter: null,
      key: 0,

      statusOptions: ['active', 'hidden', 'disabled'],
      questionTypeOptions: ['multiple_choice', 'select_choice']
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    vSelect
  },
  methods: {
    init () {
      if (this.data_local.meta && this.data_local.meta.options) {
        this.data_local.meta.options.forEach((item, index) => {
          const answer = this.data_local.meta.answers.find((o) => o.text === item.text)
          this.data_local.meta.options[index].correct = answer.correct
        })
        this.key++
      }
    },
    add_answer () {
      this.data_local.meta.options.push({
        text: '',
        icon: 'default'
      })
    },
    remove_answer (index) {
      this.data_local.meta.options.splice(index, 1)
    },
    toggle_correct (index) {
      this.data_local.meta.options[index].correct = !this.data_local.meta.options[index].correct
      this.key++
    },
    question_update_data () {
      this.$emit('update_questionData', this.data_local)
    },
    reset_data () {
      this.data_local = JSON.parse(JSON.stringify(this.data))
      this.init()
    }
  },
  created () {
    this.init()
  }
}
</script>

<style scoped></style>
